import React from 'react';
import styled from 'styled-components';
import UISlider from '@mui/material/Slider';
import {Colors} from '../../utils/style/colors';
import {fontSize, Text} from '../../utils/style/texts';
import {closestTo} from "../../utils/functions";

export const Slider = props => {
    let {width, hideLabels, min, max, minLabel, maxLabel, stepCount, onChange, onValueNotFound, ...other} = props;
    React.useEffect(() => {
        if(+props.value <= +max) return;
        if(onValueNotFound) onValueNotFound();
    }, [props, max, onValueNotFound]);
    
    const stepSize = Math.ceil((max - min) / (stepCount - 1));
    const steps = [];
    steps.push(min);
    for (let i = 1; i < stepCount - 1; i++) {
        steps.push(steps[i - 1] + stepSize);
    }
    steps.push(max);

    const value = closestTo(+props.value, steps);

    return (
        <Wrapper width={width}>
            {!hideLabels && (<MinValue>{minLabel}</MinValue>)}
            <UISlider
                {...other}
                value={value}
                min={min}
                max={max}
                step={stepSize}
                color="primary"
                onChange={(e, val) => onChange(val)}
            />
            {!hideLabels && (<MaxValue>{maxLabel}</MaxValue>)}
        </Wrapper>
    );
}

const Wrapper = styled.div`
  position: relative;
  width: auto;
  ${props => props.width && `
    width: ${props.width}px;
  `}
`;

const MinValue = styled(Text)`
  position: absolute;
  top: -8px;
  left: -3px;
  font-size: ${fontSize.s}pt;
  color: ${Colors.gray30};
`;
const MaxValue = styled(Text)`
  position: absolute;
  top: -8px;
  right: -3px;
  font-size: ${fontSize.s}pt;
  color: ${Colors.gray30};
`;